// extracted by mini-css-extract-plugin
module.exports = {"Spinner__container":"Spinner_Spinner__container__14khH"};